// extracted by mini-css-extract-plugin
export default {"root":"InputTag_root__1eOHi","addTag":"InputTag_addTag__p+uW8","input":"InputTag_input__o48Do"};